/* ---------------------------------=-=-=-=-=-=-=-=-=-=----------------------------------- */
import axios from "axios";
import { useEffect, useState } from "react";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import Spinner from "react-bootstrap/Spinner";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { FiDelete } from "react-icons/fi";
import { Badge, ListGroup, Navbar } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useContext } from "react";
import { CartContext } from "../components/CartContext";
import { TiArrowBackOutline } from "react-icons/ti";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import toast from "react-hot-toast";

import { apibasePath } from "../config";
import { AddRemark } from "../APICalls";
import { CaretDown, CaretDownFill, ChevronDown, PencilSquare } from "react-bootstrap-icons";
import { AnimatePresence, motion } from "framer-motion";
import LoadingImg from "../shared/LoadingImg";

const AddCartDetails = () => {
  const [cartDetails, setCartDetails] = useState([]);
  const [loading, setLoading] = useState(false);
  const [logo, setLogo] = useState(null);
  const [name, setName] = useState("");
  const [customerName, setCustomerName] = useState("");
  const navigate = useNavigate();
  const [cartSummary, setCartSummary] = useState([]);
  const [btnDisabled, setBtnDisabled] = useState(false);
  const [outOfStock, setOutOfStock] = useState(false);

  const [showCollapse, setShowCollapse] = useState(false);

  const [modalShow, setModalShow] = useState(null);

  const [showOutOfStockModal, setShowOutOfStockModal] = useState(false);

  const Api_Url = `${apibasePath}/client/customer-cart-details/`;
  //customer cart summary
  const cart_api = `${apibasePath}/client/customer-cart-summary/`;
  const Token = localStorage.getItem("token");
  const TotalCartSummary = async () => {
    try {
      setLoading(true);
      const response = await axios.get(cart_api, {
        headers: {
          Authorization: `bearer ${Token}`,
          "Content-Type": "application/json",
        },
      });
      console.log("TotalCartSummary", response.data);
      setCartSummary(response?.data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching cart summary:", error);
      setLoading(false);
      // Optionally set an error state to display an error message to the user
    }
  };

  useEffect(() => {
    TotalCartSummary();
  }, []);

  //company logo
  const Api_url = `${apibasePath}/client/profiles/company/`;

  const fetchdatas = async () => {
    try {
      // setLoading(true)
      let response = await axios.get(Api_url, {
        headers: { "Content-Type": "application/json" },
      });
      console.log("responseFGFGFG", response.data.logo);
      setLogo(response.data.logo);
      setName(response.data.name);
      setLoading(false);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchdatas();
  }, []);

  //brandlogo
  const Api = `${apibasePath}/client/profiles/brand/`;
  const [brandLogo, setBrandLogo] = useState(null);

  useEffect(() => {
    const fetchdata = async () => {
      try {
        let response = await axios.get(Api, {
          headers: { "Content-Type": "application/json" },
        });
        console.log("responseeeeeeeeee", response);
        setBrandLogo(response.data.logo);
      } catch (error) {
        console.error(error);
      }
    };

    fetchdata();
  }, []);
  // final submit

  const finalCardApi = `${apibasePath}/client/final-cart/`;
  const payload = {};

  /* jwdvbhv  sandeep -=-=-=-=-=-=-=-=- */

  // const handleSubmit = async () => {
  //   const Token = localStorage.getItem("token");
  //   console.log("Token:", Token);

  //   try {
  //     // setLoading(true);
  //     let res = await axios.get(Api_Url, {
  //       headers: {
  //         Authorization: `bearer ${Token}`,
  //         "Content-Type": "application/json",
  //       },
  //     });
  //     console.log("response", res);
  //     setCartDetails(res?.data);

  //     const hasOutOfStockItems = cartDetails.some(
  //       (item) => item.in_stock === false
  //     );

  //     console.log("handle out", hasOutOfStockItems);
  //     if (hasOutOfStockItems) {
  //       console.log("item out of stock");
  //       setShowOutOfStockModal(true);
  //       return;
  //     } else {
  //       try {
  //         const response = await axios.post(finalCardApi, payload, {
  //           headers: {
  //             Authorization: `bearer ${Token}`,
  //             "Content-Type": "application/json",
  //           },
  //         });

  //         console.log("Final submission response:", response);
  //         // navigate("/thankyou", { replace: true });
  //         // alert("Cart submitted successfully!");
  //       } catch (error) {
  //         console.error("Error submitting cart:", error);
  //         alert("Failed to submit cart. Please try again.");
  //       }
  //     }

  //     setLoading(false);
  //   } catch (error) {
  //     console.error(error);
  //     setLoading(false);
  //   }
  // };

  // const removeOutOfStockItems = () => {
  //   const updatedCart = cartDetails.filter(item => item.in_stock !== false);
  //   setCartDetails(updatedCart);
  //   setShowOutOfStockModal(false);
  // };
  // customer name

  const handleSubmit = async () => {
    const Token = localStorage.getItem("token");
    console.log("Token:", Token);

    setLoading(true);

    try {
      const res = await axios.get(Api_Url, {
        headers: {
          Authorization: `bearer ${Token}`,
          "Content-Type": "application/json",
        },
      });
      console.log("gooodf");
      const cartItems = res?.data || [];
      console.log("Fetched Cart Items:", cartItems);

      setCartDetails(cartItems); // Update state if needed elsewhere

      const hasOutOfStockItems = cartItems.some(
        (item) => item.in_stock === false
      );
      console.log("Has Out of Stock Items:", hasOutOfStockItems);

      if (hasOutOfStockItems) {
        setShowOutOfStockModal(true);
        setLoading(false);
        return;
      }

      // Proceed with final submission
      try {
        const response = await axios.post(finalCardApi, payload, {
          headers: {
            Authorization: `bearer ${Token}`,
            "Content-Type": "application/json",
          },
        });

        console.log("Final submission response:", response);
        navigate("/thankyou", { replace: true });
      } catch (submitError) {
        console.error("Error submitting cart:", submitError);
      }
    } catch (error) {
      console.error("Error fetching cart details:", error);
    } finally {
      setLoading(false);
    }
  };

  /* jwdvbhv  sandeep -=-=-=-=-=-=-=-=- */

  const customerApi = `${apibasePath}/client/customer-name/`;

  const fetchCustomerName = async () => {
    const Token = localStorage.getItem("token");

    try {
      let response = await axios.get(customerApi, {
        headers: {
          Authorization: `bearer ${Token}`,
          "Content-Type": "application/json",
        },
      });
      console.log("Customer API Response:", response.data);

      if (response.data?.name) {
        setCustomerName(response.data.name); // Set name only if it exists
      } else {
        console.warn("Customer name not found in API response");
      }
    } catch (error) {
      console.error("Error fetching customer name:", error);
    }
  };

  useEffect(() => {
    fetchCustomerName(); // Call function inside useEffect
  }, []);

  const featchData = async () => {
    const Token = localStorage.getItem("token");

    try {
      setLoading(true);
      let res = await axios.get(Api_Url, {
        headers: {
          Authorization: `bearer ${Token}`,
          "Content-Type": "application/json",
        },
      });
      console.log("response", res);
      setCartDetails(res?.data);

      setLoading(false);
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    featchData();
  }, []);

  const count_Api = `${apibasePath}/client/cart-count/`;

  const cartCountfeatchData = async () => {
    const Token = localStorage.getItem("token");
    try {
      const response = await axios.get(count_Api, {
        headers: {
          Authorization: `bearer ${Token}`,
          "Content-Type": "application/json",
        },
      });
      console.log("carttssssscount", response?.data?.cart_count);
    } catch (error) {
      console.error("Error fetching sizes:", error);
    }
  };

  const { cartItems, setCartItems } = useContext(CartContext);

  const handleDelete = async (item) => {
    const Token = localStorage.getItem("token");
    console.log("ITREWXGU", item);

    try {
      await axios.delete(`${apibasePath}/client/cart/remove/${item.id}/`, {
        headers: {
          Authorization: `bearer ${Token}`,
          "Content-Type": "application/json",
        },
      });

      const updatedCart = cartItems.filter((tag) => tag !== item.item_tag);
      setCartItems(updatedCart);
      cartCountfeatchData();
      TotalCartSummary();
      featchData();
      setLoading(false);
      // alert("Deleted successfully");
    } catch (error) {
      console.error("Delete error:", error);
    }
  };

  const update_Api = `${apibasePath}/client/cart/update`;

  const handleUpdate = async (item, quantity) => {
    const Token = localStorage.getItem("token");

    try {
      let res = await axios.put(
        `${update_Api}/${item.id}/`,
        { quantity: quantity },
        {
          headers: {
            Authorization: `bearer ${Token}`,
            "Content-Type": "application/json",
          },
        }
      );
      console.log("res", res);
      featchData();
      setLoading(false);
    } catch (error) {
      console.error("error", error);
    }
  };

  const handleIncrement = (item) => {
    handleUpdate(item, item.quantity + 1);
  };

  const handleDecrement = (item) => {
    if (item.quantity > 1) {
      handleUpdate(item, item.quantity - 1);
    }
  };

  const handleContextMenu = (event) => {
    event.preventDefault();
  };

  if (loading) {
    return (
      <div
        style={{
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          position: "absolute",
        }}
        className="slide"
      >
        <Spinner animation="border" role="status" variant="primary">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </div>
    );
  }

  // const handleButton = () => {
  //   featchData();

  // if(outOfStock) {
  //   console.log("remove item");
  // }

  // }

  return (
    <div>
      <GetModal
        featchData={featchData}
        modalShow={modalShow}
        show={modalShow != null}
        onHide={() => setModalShow(null)}
      />
      <Navbar className="bg-body-tertiary fixed-top">
      
        <Container fluid>
          <Navbar.Brand className="ms-2">
            <div
              style={{
                width: "100px",
                height: "50px",
                borderRadius: "10px",
                overflow: "hidden",
              }}
            >
              <img
                src={logo}
                alt="companylogo"
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
              />
            </div>
          </Navbar.Brand>
          <Navbar.Brand
            style={{
              color: "#23395B",
              fontFamily: "Roboto",
              fontWeight: "600",
              marginRight: "auto",
              fontSize: "17px",
            }}
          >
            {name}
          </Navbar.Brand>
          <Navbar.Brand
            style={{
              color: "#23395B",
              fontFamily: "Roboto",
              fontWeight: "600",
              marginRight: "auto",
              fontSize: "17px",
            }}
          >
            Shopping Cart
          </Navbar.Brand>
        </Container>
      </Navbar>
      {/* <Navbar
        style={{
          marginTop: "",
          position: "fixed",
          top: "8%",
          backgroundColor: "white",
          zIndex: 999,
          width: "100%",
          marginLeft: "62px",
        }}
      >
        <div>
          <h3 style={{ marginTop: "12px" }}>Cart Items</h3>
        </div>
      </Navbar> */}
      <Container fluid>
        <Navbar.Brand className="ms-2">
          <div>
            {/* {showBackButton && (
                <div style={{ marginRight: "90px" }}>
                  <TiArrowBackOutline
                    onClick={handleBack}
                    style={{ width: "40px", height: "40px" }}
                  />
                </div>
              )} */}
          </div>
        </Navbar.Brand>
      </Container>

      <Container style={{ padding: "2%", marginTop: "75px" }}>
        <h3>Cart Items</h3>

        {cartDetails && cartDetails.length > 0 ? (
          cartDetails.map((item, index) => (
            <Row
              key={index}
              style={{
                margin: "10px 5px",
                borderRadius: "10px",
                boxShadow: "0px 0.5px 7px #aaa",
                padding: "10px",
                // marginBottom: "10px",
              }}
              className="align-items-center"
            >
              <Col xs={12} md={7} className="d-flex align-items-center  ">
                <Col xs={6} className="p-0">
                  <Card
                    style={{
                      width: "100%",
                      overflow: "hidden",
                      border: "none",
                    }}
                  >
                    {/* <Card.Img
                      variant="top"
                      style={{
                        maxHeight: "400px",
                        minHeight: "200px",
                        objectFit: "cover",
                        borderRadius: "10px",
                        filter:
                          item.in_stock === false
                            ? "#44403cscale(100%)"
                            : "none",
                        opacity: item.in_stock === false ? 0.7 : 1,
                      }}
                      // src={item.image ? item.image : "./images/noimage.jpg"}
                      // src="https://img.freepik.com/premium-photo/convenient-shopping-product-package-boxes-cart-with-shopping-list-generative-ai_94628-2860.jpg"
                      onContextMenu={handleContextMenu}
                    >
                    </Card.Img> */}
                    <LoadingImg product={item} handleNavigateToProduct={null} handleContextMenu={handleContextMenu} />
                  </Card>
                </Col>
                <Col xs={6}>
                  <Card
                    style={{
                      width: "100%",
                      border: "none",
                      marginLeft: "20px",
                    }}
                  >
                    <Card.Title
                      style={{ background: "#f8f9fa", marginBottom: 0 }}
                    >
                      {item.item_tag}{" "}
                      <span className="d-none d-md-inline">
                        {" "}
                        {item.item_name} {" "}
                      </span>
                      <p className="d-md-none"> {item.item_name} </p>
                    </Card.Title>
                    <Card.Body style={{ background: "#f8f9fa" }}>
                      <Card.Text className="cards" style={{}}>
                        {/* <p
                          style={{
                            fontFamily: "Roboto",
                            fontWeight: "600",
                            fontSize: "18px",
                            lineHeight: "0",
                            letterSpacing: "0",
                          }}
                        >
                         {item.item_name} ({item.item_tag})
                        </p>
                        <p
                          style={{
                            fontFamily: "Roboto",
                            fontWeight: "600",
                            fontSize: "18px",
                            lineHeight: "1",
                            letterSpacing: "0",
                          }}
                        >
                          
                        </p> */}
                        <p
                          style={{
                            lineHeight: "0.5",
                            fontFamily: "Roboto",
                            fontWeight: "400",
                          }}
                        >
                          <span
                            style={{ fontWeight: "bold", color: "#44403c" }}
                          >
                            {" "}
                            Gross Wt
                          </span>
                          &nbsp; :{" "}
                          {item.gross_weight % 1 === 0
                            ? item.gross_weight
                            : Number(item.gross_weight).toFixed(3) ||
                            "N/A"}{" "}
                          gm
                        </p>
                        <p
                          style={{
                            lineHeight: "0.5",
                            fontFamily: "Roboto",
                            fontWeight: "400",
                          }}
                        >
                          <span
                            style={{ fontWeight: "bold", color: "#44403c" }}
                          >
                            {" "}
                            Net Wt
                          </span>
                          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; :{" "}
                          {item.net_weight % 1 === 0
                            ? item.net_weight
                            : Number(item.net_weight).toFixed(3) || "N/A"}{" "}
                          gm
                        </p>
                        <p
                          style={{
                            lineHeight: "0.5",
                            fontFamily: "Roboto",
                            fontWeight: "400",
                          }}
                        >
                          <span
                            style={{ fontWeight: "bold", color: "#44403c" }}
                          >
                            {" "}
                            Stone Wt
                          </span>
                          &nbsp; :{" "}
                          {item.stone_weight % 1 === 0
                            ? item.stone_weight
                            : Number(item.stone_weight).toFixed(3) ||
                            "N/A"}{" "}
                          gm
                        </p>
                        <p
                          style={{
                            lineHeight: "0.5",
                            fontFamily: "Roboto",
                            fontWeight: "400",
                          }}
                        >
                          <span
                            style={{ fontWeight: "bold", color: "#44403c" }}
                          >
                            {" "}
                            Size
                          </span>
                          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:{" "}
                          {item.size || "N/A"}
                        </p>

                        {item.in_stock === false && (
                          <span className="ms-2 " style={{ color: "red" }}>
                            <b>Out of Stock</b>
                          </span>
                        )}
                      </Card.Text>
                    </Card.Body>
                  </Card>
                </Col>
              </Col>
              <Col xs={12} md={5} className="text-md-end mt-2 mt-md-0 d-flex flex-md-column align-items-end gap-0 gap-md-1 justify-content-end  "
              >
                {/* <div className="d-flex flex-column  mt-3 align-self-start align-items-start align-content-start align-items-start" >

             
                <button
                  type="button"
                  class="btn btn-link"
                  onClick={() => setShowCollapse(!showCollapse)}
                  style={{marginRight:'auto'}}
                  
                >
                  View Remark <CaretDownFill style={{ marginLeft: "-4px" }} />
                </button>

                <AnimatePresence>

                

                {showCollapse && (
                  <motion.div 
                  initial={{ x:0,y:0, scale:0.4,  }}
                  animate= {{x:0,y:0, scale:1,  }}
                  exit={{ x:0,y:0, scale:0.1 }}
                  style={{ transformOrigin: '10px 0' }}
                  transition={{duration:0.2, ease:'easeIn' }}

                  
                  className={`collapsible ${showCollapse ? "open" : ""}`}>
                    <div class="card card-body">
                      Anim pariatur cliche reprehenderit, enim eiusmod high life
                      accusamus terry richardson ad squid
                      
                    </div>
                  </motion.div>
                )}
                </AnimatePresence>
                </div> */}
                {/* <div className="d-flex   "> */}
                {/* <Button
                    variant="outline-secondary"
                    size="sm"
                    onClick={() => handleDecrement(item)}
                  >
                    -
                  </Button>
                  <span className="mx-2">{item.quantity}</span>
                  <Button
                    variant="outline-secondary"
                    size="sm"
                    onClick={() => handleIncrement(item)}
                  >
                    +
                  </Button> */}

                <div className="d-flex flex-md-column gap-1  ">
                  <Button
                    variant="outline-danger"
                    className="ms-2  "
                    // style={{  }}
                    onClick={() => handleDelete(item)}
                  >
                    Remove
                  </Button>
                  <Button
                    variant="info"
                    style={{
                      background: '#396d71',
                      border: '1px solid #396d71',
                      color: 'white'
                    }}
                    className="ms-2   "
                    onClick={() =>
                      setModalShow({
                        id: item?.id,
                        name: item?.item_name,
                        tag: item?.item_tag,
                        comment: item?.comment,
                      })
                    }
                  >
                    Comments
                  </Button>
                </div>
                {/* </div> */}
              </Col>
            </Row>
          ))
        ) : (
          <div className="text-center">
            <p
              style={{
                fontSize: "24px",
                fontWeight: "bold",
                marginTop: "40px",
              }}
            >
              Cart is Empty
            </p>
            {/* <Button
              variant="info"
              className="ms-2 mt-1"
              onClick={() => setModalShow(true)}
            >
              Add Remark
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
	<path fill="currentColor" d="M22 4c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4zm-2 13.17L18.83 16H4V4h16zM13 5h-2v4H7v2h4v4h2v-4h4V9h-4z" />
</svg>
            </Button> */}
          </div>
        )}

        {cartDetails && cartDetails.length > 0 ? (
          <Card className="shadow-sm mt-4">
            <Card.Body>
              {/* Cart Summary Section */}
              <Card.Title className="mb-3 border-bottom pb-2">
                CART SUMMARY
              </Card.Title>
              <ListGroup variant="flush" className="mb-4">
                <ListGroup.Item className="d-flex justify-content-between align-items-center py-2 px-0">
                  <span>Customer Code </span>
                  <span className="text-muted">
                    {cartSummary.customer_code}
                  </span>
                </ListGroup.Item>
                <ListGroup.Item className="d-flex justify-content-between align-items-center py-2 px-0">
                  <span>Total Quantity </span>
                  <span className="text-muted">
                    {cartSummary.total_quantity}
                  </span>
                </ListGroup.Item>
                <ListGroup.Item className="d-flex justify-content-between align-items-center py-2 px-0">
                  <span>Total Gross Wt </span>
                  <span className="text-muted">
                    {cartSummary.total_gross_weight % 1 === 0
                      ? cartSummary.total_gross_weight
                      : Number(cartSummary.total_gross_weight).toFixed(3) ||
                      "N/A"}{" "}
                    gm
                  </span>
                </ListGroup.Item>
                <ListGroup.Item className="d-flex justify-content-between align-items-center py-2 px-0">
                  <span>Total Stone Wt </span>
                  <span className="text-muted">
                    {cartSummary.total_stone_weight % 1 === 0
                      ? cartSummary.total_stone_weight
                      : Number(cartSummary.total_stone_weight).toFixed(3) ||
                      "N/A"}{" "}
                    gm
                  </span>
                </ListGroup.Item>
                <ListGroup.Item className="d-flex justify-content-between align-items-center py-2 px-0">
                  <span>Total Net Wt </span>
                  <span className="text-muted">
                    {cartSummary.total_net_weight % 1 === 0
                      ? cartSummary.total_net_weight
                      : Number(cartSummary.total_net_weight).toFixed(3) ||
                      "N/A"}{" "}
                    gm
                  </span>
                </ListGroup.Item>
              </ListGroup>

              {/* Price Details Section */}
              {/* <Card.Title className="mb-3 border-bottom pb-2">PRICE DETAILS</Card.Title>
        <ListGroup variant="flush">
          <ListGroup.Item className="d-flex justify-content-between align-items-center py-2 px-0">
            <span>Price (1 item)</span>
            <span>¥1,200</span>
          </ListGroup.Item>
          <ListGroup.Item className="d-flex justify-content-between align-items-center py-2 px-0">
            <span>Discount</span>
            <Badge bg="success">- ¥97</Badge>
          </ListGroup.Item>
          <ListGroup.Item className="d-flex justify-content-between align-items-center py-2 px-0">
            <span>Delivery Charges</span>
            <Badge bg="success">Free</Badge>
          </ListGroup.Item>
          
          <ListGroup.Item className="py-2 px-0">
            <hr className="my-2" />
          </ListGroup.Item>
          
          <ListGroup.Item className="d-flex justify-content-between align-items-center py-2 px-0 fw-bold">
            <span>Total Amount</span>
            <span>¥1,103</span>
          </ListGroup.Item>
          
          <ListGroup.Item className="py-2 px-0">
            <hr className="my-2" />
          </ListGroup.Item>
          
          <ListGroup.Item className="text-center text-success py-2 px-0">
            You will save ¥97 on this order
          </ListGroup.Item>
        </ListGroup> */}
            </Card.Body>
          </Card>
        ) : (
          <div style={{ marginTop: "20%" }}></div>
        )}

        <div>
          <div className="container" style={{ paddingBottom: "100px" }}>
            {/* Out of Stock Modal */}
            <Modal
              show={showOutOfStockModal}
              onHide={() => setShowOutOfStockModal(false)}
            >
              <Modal.Header closeButton></Modal.Header>
              <Modal.Body>
                <p>
                  Your cart contains items that are out of stock. Please remove
                  them to proceed.
                </p>
                <div className="d-flex justify-content-between mt-4">
                  <Button
                    variant="outline-secondary"
                    onClick={() => setShowOutOfStockModal(false)}
                  >
                    Cancel
                  </Button>
                  {/* <Button 
              variant="danger" 
              onClick={removeOutOfStockItems}
            >
              Remove All Out-of-Stock Items
            </Button> */}
                </div>
              </Modal.Body>
            </Modal>
          </div>

          {cartDetails && cartDetails.length > 0 && (
            <div align="center" style={{ paddingBottom: "70px" }}>
              <Button
                style={{
                  backgroundColor: "#D1B458",
                  border: "none",
                  paddingLeft: "24%",
                  paddingRight: "24%",
                  paddingTop: "15px",
                  paddingBottom: "15px",
                  fontSize: "21px",
                  marginTop: "5%",
                }}
                size="sl"
                onClick={handleSubmit}
              >
                <b>Final Submission</b>
              </Button>
            </div>
          )}

          <div
            style={{
              bottom: 0,
              left: 0,
              width: "100%",
              textAlign: "center",
              fontFamily: "Roboto",
              padding: "10px 0",
              // backgroundColor: "white",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexWrap: "wrap",
              }}
            >
              <h4
                style={{
                  fontSize: "14px",
                  marginTop: "24px",
                  marginBottom: "0px",
                  color: "#35646E",
                }}
              >
                POWERED BY
              </h4>
              <div
                style={{
                  width: "100px",
                  height: "60px",
                  borderRadius: "10px",
                  overflow: "hidden",
                  alignItems: "center",
                  justifyContent: "center",
                  marginLeft: "5px",
                }}
              >
                <img
                  src={brandLogo}
                  alt="Brandlogo"
                  style={{ width: "100%", height: "100%", objectFit: "cover" }}
                />
              </div>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default AddCartDetails;

function GetModal(props) {
  const [comment, setComment] = useState("");
  const [editClk, setEditClk] = useState(false);

  // const { cartItems, setCartItems } = useContext(CartContext);


  useEffect(() => {
    setComment(props.modalShow?.comment);
    // console.log(cartItems)
  }, [props]);

  const handleCmntClick = async () => {
    if (!comment || comment.trim()?.length < 1) {
      toast.error("No Comment Found");
      return;
    }

    const data = await AddRemark(props.modalShow.id, { comment: comment });
    console.log(data.message)

    if (data?.message) {
      toast.success(`Comment ${props.modalShow?.comment ? "Edited" : "Added"} Successfully`);
      setComment("");
      setEditClk(false);
      props.featchData()

    } else {
      setEditClk(false);
      toast.error("Failed to Add Comment");
      return;
    }

    props.onHide();
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton className="border-0">
        <Modal.Title id="contained-modal-title-vcenter"> Comments</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <h4> </h4>
        <p>
          {" "}
          For {props.modalShow?.tag} {props.modalShow?.name}{" "}
        </p>
        {(comment && !editClk) ?
          <div className="border rounded-3  d-flex align-items-center gap-2 p-2 px-4" style={{ width: 'max-content' }} >
            <span> {comment} </span>
            <PencilSquare onClick={() => setEditClk(true)} style={{ cursor: 'pointer' }} />
          </div>
          :
          <InputGroup className="mb-3">
            {/* <InputGroup.Text id="basic-addon1"> */}
              {/* <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
            >
              <path
                fill="currentColor"
                d="M22 4c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4zm-2 13.17L18.83 16H4V4h16zM13 5h-2v4H7v2h4v4h2v-4h4V9h-4z"
              />
            </svg> */}
            {/* </InputGroup.Text> */}



            <Form.Control
              as="textarea"
              aria-label="With textarea"
              value={comment}
              onChange={(e) => setComment(e.target.value)}
              style={{ height: '20px' }}
            />

          </InputGroup>
        }
      </Modal.Body>
      <Modal.Footer className="border-0">
        <Button variant="outline-secondary" onClick={props.onHide}>
          Cancel
        </Button>
        <Button
          variant="info"
          style={{
            background: '#396d71',
            border: '1px solid #396d71',
            color: 'white'
          }}
          onClick={(e) => {
            handleCmntClick();
          }}
        >
          {props.modalShow?.comment ? 'Submit' : 'Add'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
